<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { AloDbUser } from '@/models/alodb/AloDbUser'
import AdminUserForm from '@/components/admin/user/AdminUserForm.vue'
import AdminForm from '@/components/admin/AdminForm.vue'
import { SecurityItemsKeys } from '@/enum/SecurityItems'


@Component({
  name: 'AdminUser', 
  components:{AdminUserForm}
})
export default class AdminUser extends AdminForm<AloDbUser> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_USER].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
 get itemTypeName(){
   return "User"
 }
 
 get showTitle(){
   return !(this.original.id! > 0)
 }

}
</script>